import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import { getFormElementGroupStylesAsClassName } from './form-element-group-styles';
import { twMerge } from 'tailwind-merge';

export type IFormElementGroupProps = WithChildrenCommonProps<unknown>;

export const FormElementGroup = React.forwardRef(
  (
    props: IFormElementGroupProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ): JSX.Element => {
    const { children, className: classNameProps, ...rest } = props;
    const twClassName = twMerge(
      getFormElementGroupStylesAsClassName(),
      classNameProps
    );
    return (
      <div ref={ref} className={twClassName} {...rest}>
        {children}
      </div>
    );
  }
);

FormElementGroup.displayName = 'FormElementGroup';
